import { PropsWithChildren } from 'react';

import ChannelProvider from '@/channels/ChannelProvider';
import { personMessagesChannelName } from '@/channels/utils/channelNames';

import { Props } from './types';

const PersonMessagesChannel = ({ children, personId }: PropsWithChildren<Props>) => {
  return (
    <ChannelProvider channelName={personMessagesChannelName(personId)}>{children}</ChannelProvider>
  );
};

export default PersonMessagesChannel;
